import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Button, Modal, Paper, Typography, Box } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { deleteOnBoardingTask, deleteOnBoardingCategory } from "@redux/actions";
import { modalBody, modalHeader, modalStyle } from "@styles/styledComponents";

const styles = (theme) => ({
  paper: {
    boxShadow: "none !important",
  },
  submitButton: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
});

const DeleteCategoryTaskModal = ({
  deletedTaskData,
  setDeletedTaskData,
  deletedCategoryData,
  setDeletedCategoryData,
  transitionType,
  classes,
}) => {
  const dispatch = useDispatch();
  function handleDeleteTask() {
    if (deletedTaskData.category_id) {
      dispatch(
        deleteOnBoardingTask({
          taskData: deletedTaskData,
          category_type: transitionType,
        })
      ).then(() => {
        setDeletedTaskData({
          category_id: "",
          task_id: "",
        });
      });
    } else {
      dispatch(
        deleteOnBoardingCategory({
          categoryId: deletedCategoryData,
          category_type: transitionType,
        })
      ).then(() => {
        setDeletedCategoryData(null);
      });
    }
  }

  return (
    <Modal
      open={deletedTaskData}
      onClose={() => {
        setDeletedTaskData({
          category_id: "",
          task_id: "",
        });
        setDeletedCategoryData(null);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={modalStyle}
    >
      <Paper elevation={1} variant="normal" square>
        <div style={modalHeader}>
          <Typography variant="h6">
            Delete {deletedCategoryData ? "Category" : "Task"} Confirmation
          </Typography>
        </div>
        <div style={modalBody}>
          <Paper className={classes.paper}>
            <Typography variant="body1" style={{ padding: "20px 10px" }}>
              Are you sure you want to delete this{" "}
              {deletedCategoryData ? "category" : "task"}?
            </Typography>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={handleDeleteTask}
              >
                Delete
              </Button>

              <Button
                type="button"
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => {
                  setDeletedTaskData({
                    category_id: "",
                    task_id: "",
                  });
                  setDeletedCategoryData(null);
                }}
              >
                Close
              </Button>
            </Box>
          </Paper>
        </div>
      </Paper>
    </Modal>
  );
};

export default withStyles(styles)(DeleteCategoryTaskModal);
